import React from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi2';

// v2_2026 FAQ — mirrors the extension's UpsellModalD. If backend credit amounts
// or seat counts change, update the literal numbers here too.
const FAQ_ITEMS = [
  {
    question: "What's included in every plan?",
    answer:
      "Every plan unlocks the full PRO browser extension — run unlimited local extractions with every feature enabled (unlimited exports to CSV, Excel, JSON, multi-tab extraction, image downloads). On top of that, each plan includes a yearly allowance of cloud credits for running extractions on our Cloud Platform: scheduled extractions, cloud browsers, AI Page Unblocker, Data Labeling, and integrations.",
  },
  {
    question: "What's the difference between Pro, Pro+, and Team?",
    answer:
      "All three unlock the full PRO extension. They differ in cloud allowance and collaboration: Pro includes 10,000 cloud credits/year for occasional cloud runs, Pro+ includes 100,000 credits/year for heavier automation, and Team includes 200,000 credits/year plus a shared workspace with 6 seats so your whole team gets PRO and works from one dashboard.",
  },
  {
    question: 'Are plans billed monthly or yearly?',
    answer:
      "Plans are billed annually. There's no monthly option — billing once a year is how we keep the pricing this affordable. You can cancel anytime and keep access until the end of your paid year.",
  },
  {
    question: 'How do cloud credits work?',
    answer:
      'Cloud credits are only needed to run extractions on our cloud infrastructure — running the extension locally on your own browser is always unlimited. 1 cloud credit = 1 page extracted in the cloud, and AI features like Page Unblocker and Data Labeling also consume credits. Your full yearly allowance is granted upfront when you subscribe, and you can top up anytime if you run out.',
  },
  {
    question: 'What happens to unused credits at renewal?',
    answer:
      "Your credit balance is good for the year. Unused credits don't roll over — each renewal you start fresh with your plan's full yearly allowance. Need more before renewal? Top up anytime.",
  },
  {
    question: 'Can I invite my team?',
    answer:
      'Team collaboration is included on the Team plan, which comes with a shared workspace and 6 seats. Invite teammates from the workspace settings; every member unlocks the full PRO browser extension and shares the same dashboard, automations, schedules, and cloud database. Seats can be reassigned anytime.',
  },
  {
    question: 'Can I cancel anytime?',
    answer:
      "Yes. Cancel anytime from the billing portal. You'll keep access to your plan until the end of your current paid year and won't be charged again.",
  },
  {
    question: 'Do I still get the browser extension if I subscribe?',
    answer:
      'Yes — every plan automatically unlocks the full PRO browser extension on your own computer, with unlimited local extractions and exports. No separate license needed, and local use never consumes cloud credits.',
  },
  {
    question: 'Can I switch plans later?',
    answer:
      'Yes. Upgrade or downgrade anytime from the billing portal. Upgrades take effect immediately; downgrades take effect at your next yearly renewal.',
  },
  {
    question: 'I already bought a lifetime license — does it still work?',
    answer:
      'Yes — your lifetime license still works exactly as before. Just use your license key to register the extension and unlock PRO from Settings. No subscription required.',
  },
];

const FAQSectionV2 = ({ openIndex, setOpenIndex }) => (
  <div className="rounded-xl border border-gray-200 dark:border-gray-700/30 bg-gradient-to-br from-gray-50 dark:from-gray-900/60 to-gray-100 dark:to-gray-800/40 px-8 py-8">
    <div className="text-center mb-8">
      <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        Questions? We've Got Answers.
      </h3>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Everything you need to know about our plans and billing
      </p>
    </div>

    <div className="space-y-0">
      {FAQ_ITEMS.map((item, index) => (
        <div key={index} className={`border-b border-gray-200 dark:border-gray-800/50 transition-all duration-300 pl-4 -ml-4 ${
              openIndex === index
                ? 'border-l-2 border-l-cyan-500 dark:border-l-cyan-400'
                : 'border-l-2 border-l-transparent'
            }`}>
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between py-5 text-left group"
          >
            <span className={`text-base font-semibold transition-colors ${
              openIndex === index
                ? 'text-cyan-500 dark:text-cyan-400'
                : 'text-gray-700 dark:text-gray-300 group-hover:text-cyan-500 dark:group-hover:text-cyan-400'
            }`}>
              {item.question}
            </span>
            <HiOutlineChevronDown className={`w-5 h-5 flex-shrink-0 ml-4 text-gray-400 dark:text-gray-500 group-hover:text-cyan-500 dark:group-hover:text-cyan-400 transition-all duration-300 ${
              openIndex === index ? 'rotate-180 !text-cyan-500 dark:!text-cyan-400' : ''
            }`} />
          </button>

          <div className={`overflow-hidden transition-all duration-300 ${
            openIndex === index ? 'max-h-72 opacity-100 pb-7' : 'max-h-0 opacity-0'
          }`}>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed pr-8">
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FAQSectionV2;
